import { GridHeaders } from '@project-types/GridHeaders';
import { SkuDistrictReportGridData } from '@pages/reporting-pages/deliveries-sku-district/types/SkuDistrictReportGridData';



export const headersObject: GridHeaders<SkuDistrictReportGridData> = [
	{ label: 'Stát', key: 'country', width: '1fr' },
	{ label: 'District', key: 'executionPlaceName', width: '1fr' },
	
	{ label: 'Total - Objem [hl]', key: 'total_volume', width: '1fr' },
	{ label: 'Total - Váha [t]', key: 'total_weight', width: '1fr' },
	{ label: 'Total - Počet objednávek', key: 'total_ordersCount', width: '1fr' },
]